import React from 'react';
import { BUSINESS } from '@/lib/businessConfig';

const AVATAR_GRADIENTS = [
  'linear-gradient(135deg, #c4a87c, #5D4A3B)',
  'linear-gradient(135deg, #ede2cc, #a98a5f)',
  'linear-gradient(135deg, #5D4A3B, #1C1814)',
  'linear-gradient(135deg, #a98a5f, #c4a87c)',
];

export default function SocialProof({ 
  count = 4,
  text = '2.199 πιστοποιημένες κριτικές στο Fresha',
  rating = `${BUSINESS.reviews.summaryEl} στο Fresha`,
  stars = 5,
  className = '',
}) {
  return (
    <div className={`flex items-center gap-[22px] pt-9 border-t border-brown/15 flex-wrap ${className}`}>
      <div className="flex">
        {Array.from({ length: count }).map((_, i) => (
          <div 
            key={i}
            className="w-[42px] h-[42px] rounded-full border-[2.5px] border-cream-bg"
            style={{ 
              marginLeft: i === 0 ? 0 : '-12px',
              background: AVATAR_GRADIENTS[i % AVATAR_GRADIENTS.length],
            }}
          />
        ))}
      </div>
      <div>
        <strong className="block text-[15px] mb-[3px] font-semibold text-warm-black">
          {text}
        </strong>
        <div className="text-gold tracking-[3px] text-body-s">
          {'★'.repeat(stars)}
          <small className="text-muted tracking-normal ml-1.5">{rating}</small>
        </div>
      </div>
    </div>
  );
}